import { Col, Container, Row, Card, Table, Badge, Spinner } from 'react-bootstrap';
import '../Global.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../components/Navbar';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import api from '../api';

function Dashboard() {
    // Stateler: KPI Verileri, Trend Turnuvalar ve Son Hareketler için ayrıldı
    const [stats, setStats] = useState({
        usersCount: 0,
        recentUserCount: 0,
        sevenUsers: 0,
        matchCount: 0,
        recentMatchCount: 0,
        recentMessageCount: 0,
        totalRevenue:0
    });
    const [topTournaments, setTopTournaments] = useState([]);
    const [recentActivities, setRecentActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const token = localStorage.getItem('JWTTOKEN');

    // Dashboard verilerini çekme işlevi
    const getDashboardData = async () => {
        try {
            setLoading(true);

            // ÖRNEK: Kendi backend endpointlerini oluşturduğunda burayı açabilirsin:
            const statsRes = await api.get("/v1/admin/dashboard", { headers: { Authorization: `Bearer ${token}` } });
            setStats(statsRes.data);

            // Mevcut aktif/yeni turnuvaları çekip vitrine (ilk 4 tanesini) koyuyoruz:



            // MOCK VERİLER (Kendi API verilerini bağlayana kadar metrikleri doldurması için):



            setLoading(false);
        } catch (err) {
            console.log("Dashboard Data Error:", err);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        getDashboardData();
    }, [token, navigate]);

    // Ortak Kart Tasarım Stilleri
    const cardStyle = {
        backgroundColor: '#121212',
        border: '1px solid #252525',
        color: 'white'
    };

    return (
        <div className="app-container">
            {/* Sol Menü */}
            <Navbar />

            {/* Sağ Ana İçerik */}
            <div className="main-content">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 style={{ color: 'white', margin: 0 }}>Genel Bakış (Dashboard)</h2>
                    <span style={{ color: '#8b8b8b', fontSize: '14px' }}>
                        Sistem Durumu: <b style={{ color: '#029220' }}>● Aktif</b>
                    </span>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
                        <Spinner animation="border" variant="success" />
                        <div style={{ color: "white", marginTop: '10px' }}>Metrikler Yükleniyor...</div>
                    </div>
                ) : (
                    <>
                        {/* 1. BÖLÜM: KPI / ÖZET KARTLARI */}
                        <Row className="g-3 mb-4">
                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Toplam Kullanıcı</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: 'white' }}>
                                            {stats.usersCount.toLocaleString()}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Son 24 saat kullanıcı</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: 'white' }}>
                                            {stats?.recentUserCount?.toLocaleString()}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Bugünkü Oynanma</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#029220' }}>
                                            {stats.sevenUsers.toLocaleString()}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                        </Row>

                        {/* 2. BÖLÜM: TREND / ÖNE ÇIKAN TURNUVALAR */}

                        <Row className="g-3 mb-4">
                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Toplam Match</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: 'white' }}>
                                            {stats.matchCount.toLocaleString()}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Son 24 Saat Match</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: 'white' }}>
                                            {stats.recentMatchCount}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>Son 24 Saat atılan mesaj</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#029220' }}>
                                            {stats.recentMessageCount.toLocaleString()}
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} xl={3}>
                                <Card style={cardStyle} className="rounded-4 p-2 h-100">
                                    <Card.Body>
                                        <Card.Subtitle style={{ color: '#8b8b8b', fontSize: '13px' }}>TOTAL IAP</Card.Subtitle>
                                        <Card.Title style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#00d2ff' }}>
                                            {stats.totalRevenue.toFixed(2)}$
                                        </Card.Title>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>




                    </>
                )}
            </div>
        </div>
    );
}

export default Dashboard;